const style = () => ({
  container: ({ size }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: size(14.1)
  })
})

export default style
